/**
 * Post-Closing Queue Stage Classification
 *
 * Pure utility that mirrors the SQL CASE expression in get_post_closing_stage_analytics
 * and search_encompass_loans. "Highest achieved milestone wins."
 *
 * No React imports. No UI dependencies.
 */

export type PostClosingQueueStage =
  | 'funded'
  | 'ready_to_ship'
  | 'delivered'
  | 'conditions'
  | 'cleared'
  | 'pa_issued'
  | 'finalized';

/** Queue-context labels — used by cards, dropdown, and filter display. */
export const POST_CLOSING_QUEUE_LABELS: Record<PostClosingQueueStage, string> = {
  funded: 'Not Ready to Ship',
  ready_to_ship: 'Ready to Ship',
  delivered: 'Delivered',
  conditions: 'Conditions',
  cleared: 'Cleared',
  pa_issued: 'PA Issued',
  finalized: 'Finalized'
} as const;

interface QueueStageInput {
  recon_status?: string | null;
  first_pa_date?: string | null;
  investor_conditions_status?: 'none' | 'outstanding' | 'cleared' | null;
  shipping_investor_delivery_date?: string | null;
  ready_to_ship_date?: string | null;
}

/**
 * Classify a loan into its current post-closing queue stage.
 * Highest achieved milestone wins. Finalized takes precedence unconditionally.
 */
export function computeQueueStage(loan: QueueStageInput): PostClosingQueueStage {
  if (loan.recon_status === 'finalized' || loan.recon_status === 'pushed') {
return 'finalized';
}
  if (loan.first_pa_date) {
return 'pa_issued';
}
  const condStatus = loan.investor_conditions_status || 'none';
  if (condStatus === 'cleared') {
return 'cleared';
}
  if (condStatus === 'outstanding') {
return 'conditions';
}
  if (loan.shipping_investor_delivery_date) {
return 'delivered';
}
  if (loan.ready_to_ship_date) {
return 'ready_to_ship';
}
  return 'funded';
}
